import { validateMonthName } from '@helper/budget/parameters/validateMonth'
export const parseParametersBudgetData = (data: any[]): any[] => {
  const res = []

  for (const item of data) {
    res.push({
      'orcamento-id': item.id,
      'orcamento-ano': item.ano,
      'orcamento-mes': validateMonthName(item.mes),
      'orcamento-fator': item.taxaConversao
    })
  }

  return res
}
